import { axiosDash } from "../axios";

const baseUrl = "api/geslub_dash/v1/machine_analysis";

export const find = async (
  params: Record<string, number | string>,
): Promise<any> => {
  const res = await axiosDash.get(baseUrl, { params });
  return res.data;
};
